import { supabase } from '../../shared/supabase/supabaseClient';

export type AppointmentStaffNotifyEvent = 'new' | 'cancelled' | 'rescheduled' | 'no_show';

export const APPOINTMENT_STAFF_NOTIFY_EVENTS: readonly AppointmentStaffNotifyEvent[] = [
  'new',
  'cancelled',
  'rescheduled',
  'no_show',
] as const;

export type AppointmentScheduleSnapshot = {
  startsAt: string;
  resourceId: string;
};

/** True when horario o agenda cambian (notas/nombre no disparan aviso). */
export function didAppointmentScheduleChange(
  before: AppointmentScheduleSnapshot,
  after: AppointmentScheduleSnapshot,
): boolean {
  return before.startsAt !== after.startsAt || before.resourceId !== after.resourceId;
}

/** `rescheduled` solo si cambió starts_at o resource_id. */
export function resolveStaffNotifyAfterUpdate(args: {
  before: AppointmentScheduleSnapshot | null;
  after: AppointmentScheduleSnapshot;
}): AppointmentStaffNotifyEvent | null {
  if (!args.before) return null;
  if (!didAppointmentScheduleChange(args.before, args.after)) return null;
  return 'rescheduled';
}

/** Solo `no_show` avisa al staff en v1 (arrived/confirmed/completed = spam). */
export function resolveStaffNotifyAfterStatus(
  status: string,
): AppointmentStaffNotifyEvent | null {
  return status === 'no_show' ? 'no_show' : null;
}

/**
 * Push al staff (dueño + profesional + Agenda con view_others).
 * Fire-and-forget: fallo del edge no tumba el write del turno.
 */
export async function fireAppointmentStaffNotify(
  appointmentId: string,
  eventType: AppointmentStaffNotifyEvent,
  organizationId?: string,
): Promise<void> {
  try {
    let orgId = organizationId?.trim() || null;
    if (!orgId) {
      const { data, error } = await supabase
        .from('appointments')
        .select('organization_id')
        .eq('id', appointmentId)
        .maybeSingle();
      if (error || !data?.organization_id) {
        console.warn(
          '[appointmentsRepo] notify-new-appointment skip: missing org',
          error?.message ?? appointmentId,
          eventType,
        );
        return;
      }
      orgId = data.organization_id as string;
    }

    const { error } = await supabase.functions.invoke('notify-new-appointment', {
      body: {
        appointment_id: appointmentId,
        organization_id: orgId,
        event_type: eventType,
      },
    });
    if (error) {
      console.warn(
        '[appointmentsRepo] notify-new-appointment failed',
        error.message,
        eventType,
      );
    }
  } catch (e) {
    console.warn('[appointmentsRepo] notify-new-appointment error', e);
  }
}
